import { ApiRequest } from '@/helpers';

export const utterances = {
  namespaced: true,
  state: getInitialState(),
  actions: {
    async fetch(
      { commit },
      { recordingId, organizationId }
    ) {
      const { data } = await ApiRequest({
        method: 'get',
        url: `/recordings/${recordingId}/utterances`,
        params: {
          organizationId,
        },
      });
      const utterances = data.utterances;
      commit('setUtterances', {
        recordingId,
        utterances: utterances,
      });
      return utterances;
    },
    async fetchIfNeeded({ state, dispatch }, data) {
      if (!state.utterances[data.recordingId]) {
        await dispatch('fetch', data);
      }
      return state.utterances[data.recordingId];
    },
  },
  mutations: {
    setUtterances(state, { recordingId, utterances }) {
      state.utterances[recordingId] = utterances;
    },
    deleteUtterances(state, { recordingId }) {
      delete state.utterances[recordingId];
    },
    resetState(state) {
      Object.assign(state, getInitialState());
    },
  },
  getters: {
    get: (state) => (recordingId) => state.utterances[recordingId],
  },
};

function getInitialState() {
  return {
    utterances: {},
  };
}
